export default __webpack_public_path__ + "static/media/avatar_panda1.464b15be.mp3";